import moment from 'moment';

import { MEMOIZE_SET } from '../action-types/memoize.action-types';

export type Memoize = {
  [key: string]: any;
  memoizeExpiryTime: {
    [key: string]: moment.Moment;
  };
};

const initialState: Memoize = {
  memoizeExpiryTime: {},
};

const memoizeReducer = (state = initialState, action) => {
  switch (action.type) {
    case MEMOIZE_SET: {
      return {
        ...state,
        ...action.data,
        memoizeExpiryTime: {
          [Object.keys(action.data)[0]]: moment().add(action.timeout, 'ms'),
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default memoizeReducer;
